export default "__VITE_ASSET__JWd7$yhS__"